import { render, staticRenderFns } from "./Filtro06.vue?vue&type=template&id=0b4e5b70&"
import script from "./Filtro06.vue?vue&type=script&lang=js&"
export * from "./Filtro06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports